var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./daily.css";
import "../project/Myproject.css";
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import "../../components/tree";
import preview from '../../lib/preview.js';
var Preview = preview;
var BMAP_STATUS_SUCCESS = 0;
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, "/api/user/group", root, { pageIndex: 1, userId: authorization.getUserId() }) || this;
        _this.depUrl = ko.observable('/api/org/showdepa');
        _this.isAdd = ko.observable(false);
        _this.qunliao = ko.observable(0);
        _this.genjin = ko.observable(0);
        _this.weekStatistics = ko.observable(0); //周統計
        _this.areaFlock = ko.observable(0); //區域
        _this.chatLog = ko.observable(false); //显示聊天记录
        _this.qunliaox = ko.observable(0); //显示详细
        _this.info = ko.observable(); //聊天记录 详细
        _this.massage = ko.observable(); //聊天对话
        _this.textMessage = ko.observable(); //需要发送的普通文本
        _this.messageArr = ko.observableArray([]);
        _this.showYesterday = ko.observable(); //显示补充昨日 按钮
        _this.isDaily = ko.observable(false); //是否处于生成日报
        _this.dailyArr = ko.observableArray([]); //生成的日报
        _this.dailyType = ko.observable(); //
        _this.nowTime = ko.observable();
        _this.ProjectDailyId = ko.observable();
        _this.depId = ko.observable(); //群组
        _this.areaArr = ko.observableArray([]); //个人区域日报
        _this.weekArr = ko.observableArray([]);
        _this.isShowMore = ko.observable(true);
        return _this;
    }
    HeaderModel.prototype.GenJin1 = function (m, e) {
        if (this.weekStatistics() == 1) {
            this.weekStatistics(0);
        }
        else {
            this.weekStatistics(1);
        }
    };
    //定位
    HeaderModel.prototype.location = function (m, d, e) {
        var mapgps;
        setTimeout(function () {
            // let div = document.getElementById("44444") ;
            mapgps = d.chatMessage.split(',');
            var map = new BMap.Map(e + 'dw' + '');
            map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), 16);
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            map.addControl(new BMap.MapTypeControl());
            map.enableScrollWheelZoom(true);
            var new_point = new BMap.Point(mapgps[0], mapgps[1]);
            var marker = new BMap.Marker(new_point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.panTo(new_point);
            var i = 16;
            map.addEventListener("click", function () {
                i = i + 1;
                mapgps = d.chatMessage.split(',');
                var map = new BMap.Map(e + 'dw');
                map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), i);
                map.enableScrollWheelZoom(true);
                var new_point = new BMap.Point(mapgps[0], mapgps[1]);
                var marker = new BMap.Marker(new_point); // 创建标注
                map.addOverlay(marker); // 将标注添加到地图中
                map.panTo(new_point);
            });
        }, 1000);
    };
    HeaderModel.prototype.GenJin = function (m, e) {
        if (this.genjin() == 1) {
            this.genjin(0);
            this.dailyType('7');
        }
        else {
            this.genjin(1);
        }
    };
    HeaderModel.prototype.isSetDaily = function () {
        var _this = this;
        if (this.dailyArr().length > 0) {
            return window.popBox.show('无法重复生成日报');
        }
        ajax.get('/api/daily/yes', {
            userId: authorization.getUserId(),
            groupId: this.depId()
        }).then(function (d) {
            if (d.data == '0') {
                _this.showYesterday(false);
            }
            else {
                _this.showYesterday(true);
            }
        });
        this.dailyArr([]);
        this.isDaily(false);
        this.genjin(1);
    };
    HeaderModel.prototype.setDaily = function () {
        var _this = this;
        this.dailyType('8');
        ajax.get('/api/chat/daily', {
            type: '8',
            userId: authorization.getUserId(),
            groupId: this.depId()
        }).then(function (d) {
            _this.genjin(0);
            if (d.data == null) {
                return window.popBox.show(d.message);
            }
            if (d.data.list.length == 0) {
                return window.popBox.show('暂无日报生成');
            }
            _this.dailyArr(d.data.list);
            _this.nowTime(new Date()['Format']('yyyy-MM-dd hh:mm:ss'));
            _this.isDaily(true);
            //  this.container.querySelector('#textarr')
        });
    };
    HeaderModel.prototype.setYesterday = function () {
        var _this = this;
        this.dailyType('9');
        ajax.get('/api/chat/daily', {
            type: '9',
            userId: authorization.getUserId(),
            groupId: this.depId()
        }).then(function (d) {
            _this.genjin(0);
            if (d.data == null) {
                return window.popBox.show(d.message);
            }
            if (d.data.list.length == 0) {
                return window.popBox.show('暂无日报生成');
            }
            _this.dailyArr(d.data.list);
            _this.nowTime(new Date()['Format']('yyyy-MM-dd hh:mm:ss'));
            _this.isDaily(true);
            //  this.container.querySelector('#textarr')
        });
    };
    HeaderModel.prototype.enterDaily = function (data) {
        var _this = this;
        console.log(data);
        ajax.get('/api/chat/power', {
            projectId: data.projectId,
            userId: authorization.getUserId()
        }).then(function (d) {
            if (d.data != '1') {
                return window.popBox.show(d.message);
            }
            else {
                _this.qunliao(0);
                _this.weekStatistics(0);
                _this.chatLog(true);
                _this.loadChat(data.projectId, data.dailyId);
                // this.enterDaily1(id);
                //window.popBox.show(d.message)
            }
        });
    };
    HeaderModel.prototype.myButtonHandler = function () { };
    //加载个人区域
    HeaderModel.prototype.loadAreaChat = function (data) {
        this.areaChat(data.projectId, data.userId);
    };
    HeaderModel.prototype.areaChat = function (pid, id) {
        var _this = this;
        ajax.get('/api/groupchat/show', {
            departmentId: pid,
            userId: id
        }).then(function (d) {
            // this.qunliao(0);
            _this.weekStatistics(0);
            _this.areaArr(d.data.message);
            console.log(_this.areaArr());
            _this.areaFlock(1);
        });
    };
    //加载本周统计
    HeaderModel.prototype.loadWeek = function () {
        var _this = this;
        if (this.depId() == undefined) {
            return window.popBox.show('信息丢失');
        }
        ajax.get('/api/daily/statistics', {
            id: this.depId()
        }).then(function (d) {
            _this.weekArr(d.data);
            _this.weekStatistics(1);
        });
    };
    HeaderModel.prototype.checkCLass = function (str) {
        if (str == '0') {
            return 'red';
        }
        if (str == '1') {
            return 'green';
        }
        if (str == '2') {
            return 'yellow';
        }
        if (str == '3') {
            return 'blue';
        }
    };
    HeaderModel.prototype.QunLiao = function () {
        if (this.qunliao() == 1) {
            this.reset();
            this.dailyArr([]);
            this.isDaily(false);
            this.qunliao(0);
            this.textMessage('');
        }
        else {
            this.qunliao(1);
        }
    };
    HeaderModel.prototype.loadMessage = function (id) {
        var _this = this;
        var div = this.container.querySelector('#daily_scrollxx');
        ajax.get('/api/group/chat', {
            groupId: id
        }).then(function (d) {
            _this.messageArr(d.data.list);
            div.scrollTop = div.scrollHeight;
        });
    };
    HeaderModel.prototype.look = function (r, d) {
        console.log(r);
        console.log(d);
        // console.log(id);
        r.count('0');
        ajax.post("/api/message/date", { projectId: d.id, userId: window.localStorage.getItem("UserId") });
        this.depId(d.id);
        this.loadMessage(d.id);
        this.qunliao(1);
        this.dailyType('7');
    };
    HeaderModel.prototype.QunLiao2 = function () {
        if (this.areaFlock() == 1) {
            this.areaFlock(0);
            this.qunliao(1);
        }
        else {
            this.areaFlock(1);
        }
    };
    HeaderModel.prototype.duble = function () { };
    //是否本人
    HeaderModel.prototype.isMe = function (id) {
        if (id && id == authorization.getUserId()) {
            return true;
        }
        else {
            return false;
        }
    };
    //时间格式化
    HeaderModel.prototype.TimeEx = function (str) {
        if (str) {
            return str.split('T')[0] + ' ' + str.split('T')[1].split('.')[0];
        }
        else {
            return '';
        }
    };
    HeaderModel.prototype.enterSet = function (root, e) {
        console.log(e.keyCode);
        if (e.keyCode == 13) {
            this.setMessage();
            e.preventDefault();
            return false;
        }
        else {
            return true;
        }
    };
    HeaderModel.prototype.setMessage = function () {
        var _this = this;
        if (this.dailyType() == '7') {
            if (this.textMessage().trim() != '') {
                ajax.post('/api/group/chat', {
                    type: '7',
                    message: this.textMessage(),
                    userId: authorization.getUserId(),
                    userName: authorization.getUsername(),
                    projectId: this.depId(),
                }).then(function () {
                    _this.loadMessage(_this.depId());
                    _this.textMessage('');
                    _this.dailyType('7');
                });
            }
            else {
                return window.popBox.show('发送内容不能为空').then(function () {
                    _this.textMessage('');
                });
            }
        }
        else {
            ajax.post('/api/group/chat', {
                type: this.dailyType(),
                message: this.textMessage(),
                userId: authorization.getUserId(),
                userName: authorization.getUsername(),
                projectId: this.depId(),
                list: this.dailyArr()
            }).then(function () {
                _this.loadMessage(_this.depId());
                _this.dailyType('7');
                _this.textMessage('');
                _this.dailyArr([]);
                _this.isDaily(false);
            });
        }
    };
    //时间 排序 包括（创建时间  更新时间）
    HeaderModel.prototype.timeSort = function (index) {
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = 1;
        this.data.time_type = index;
        this.loadData();
    };
    HeaderModel.prototype.QunLiaoX = function (m, e) {
        var div = e.currentTarget.lastElementChild;
        if (this.qunliaox() == 1) {
            this.qunliaox(0);
            div.style.transform = "rotate(180deg)";
        }
        else {
            this.qunliaox(1);
            div.style.transform = "rotate(0deg)";
        }
    };
    //加载更多跟进记录
    HeaderModel.prototype.loadMoreChat = function () {
        var _this = this;
        this.isShowMore(false);
        ajax.get('/api/project/details', {
            projectId: this.ProjectDailyId()
        }).then(function (d) {
            _this.info(d.data.details[0]);
        });
        ajax.get('/api/user/chatMessage', {
            pid: this.ProjectDailyId(),
            userId: authorization.getUserId()
        }).then(function (r) {
            _this.massage(r.data.messages);
            // let chardiv = this.container.querySelector('#msg_end-xx') as HTMLDivElement
            // chardiv.scrollIntoView();
            var preview = new Preview({
                imgWrap: 'Myproject_img-xx' // 指定该容器里的图片点击预览
            });
        });
    };
    //加载跟进记录
    HeaderModel.prototype.loadChat = function (id, dId) {
        var _this = this;
        this.ProjectDailyId(id);
        this.isShowMore(true);
        ajax.get('/api/project/details', {
            projectId: id,
        }).then(function (d) {
            _this.info(d.data.details[0]);
        });
        ajax.get('/api/message/count', {
            dailyId: dId,
            projectId: id,
        }).then(function (r) {
            _this.massage(r.data.messages);
            // let chardiv = this.container.querySelector('#msg_end-xx') as HTMLDivElement
            // chardiv.scrollIntoView();
            var preview = new Preview({
                imgWrap: 'Myproject_img-xx' // 指定该容器里的图片点击预览
            });
        });
    };
    HeaderModel.prototype.close = function () {
        this.qunliao(1);
        this.chatLog(false);
    };
    HeaderModel.prototype.loadjurisdiction = function () {
        var _this = this;
        return ajax.get('/api/group/insert', {
            userId: authorization.getUserId()
        }).then(function (d) {
            if (d.data == '1') {
                _this.isAdd(true);
            }
            else {
                _this.isAdd(false);
            }
        });
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = 1;
        this.data.time_type = 2;
        return Promise.all([
            this.loadnum(),
            this.loadbubble(),
            this.loadjurisdiction(),
            this.loadData()
        ]).then(function () { });
    };
    HeaderModel.prototype.reset = function () {
        this.isShowMore(true);
        this.showYesterday(false);
        this.messageArr([]);
        this.qunliao(0);
        this.genjin(0);
        this.weekStatistics(0);
        this.areaFlock(0);
        this.qunliaox(0);
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        for (var i in d.data.list) {
            d.data.list[i].count = ko.observable(d.data.list[i].count);
        }
        return Promise.resolve(false);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container);
    };
    mModel.prototype.update = function (arg) {
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
